import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { noop } from "lodash-es";

const SpotifyConnectContext = createContext({
  spotifyAccountConnected: false,
  connectSpotifyUrl: () => "",
  disconnectFromSpotify: noop,
});

export const SpotifyConnectProvider = ({ spotifyAccountConnected, connectSpotifyUrl, children }) => {
  const [isSpotifyAccountConnected, setSpotifyAccountConnected] = useState(spotifyAccountConnected);

  const disconnectFromSpotify = useCallback(() => {
    // Mock implementation to support parallel implementation of feature backend and frontend
    setSpotifyAccountConnected(false);
  }, []);

  const value = useMemo(
    () => ({
      spotifyAccountConnected: isSpotifyAccountConnected,
      connectSpotifyUrl,
      disconnectFromSpotify,
    }),
    [connectSpotifyUrl, disconnectFromSpotify, isSpotifyAccountConnected],
  );

  return <SpotifyConnectContext.Provider value={value}>{children}</SpotifyConnectContext.Provider>;
};

export const useSpotifyConnect = () => useContext(SpotifyConnectContext);
